import NewsAdminOverview from '../../features/news/layouts/admin-overview';

export default function NewsPage() {
    return <NewsAdminOverview />;
}
